import { SingleCharacterInput } from "shared-web/components/base/input/SingleCharacterInput"

import { ErrorMessage } from "./ErrorMessage"
import { useStaffExternalIDForm } from "./useStaffExternalIDForm"

interface StepIDInputProps {
  onSubmit: (staffExternalID: string) => void
  isSubmitting: boolean
  errorMessage: string | null
}

export function StepIDInput({
  onSubmit,
  isSubmitting,
  errorMessage,
}: StepIDInputProps) {
  const { staffExternalID, onChangeStaffExternalID, onKeyDownStaffExternalID } =
    useStaffExternalIDForm(onSubmit)

  return (
    <>
      <label
        htmlFor="id-input"
        className="text-body-lg color-subtle text-center"
      >
        Enter your ID
      </label>
      <SingleCharacterInput
        id="id-input"
        data-testid="id-input"
        containerClassName="self-center"
        value={staffExternalID}
        onKeyDown={onKeyDownStaffExternalID}
        onChange={onChangeStaffExternalID}
        isLoading={isSubmitting}
        autoFocus
      />
      <ErrorMessage message={errorMessage} />
    </>
  )
}
